module.exports = __webpack_public_path__ + "img/swiper_bg2.f4d75b35.png";